.itemTypes .itemType {
    width: 50%;
    padding: 5px;
}

.itemTypes .itemType :global(table) {
    width: auto;
}

.itemTypes .itemType :global(table .itemTypeName) {
    vertical-align: middle;
    font-size: large;
}

/* OpenNeuro extensions: the item type boxes sit on the black main area. */
.itemTypes .itemType {
    vertical-align: top;
}

.itemTypes .itemType > div {
    padding: 10px;
    background-color: #ffffff;
    color: #000000;
}
